import moment from "moment";
import { useState } from "react";
import ConfirmDialogBox from "../../../confirmdiolog/ConfirmDiologBox";


const SessionCard = ({ data, onDelete }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  
const deleteHandler = () => {
  onDelete(data.userId);
};
  return (
    <div className="bg-white dark:bg-slate-900 rounded-md shadow flex flex-col h-full">

      {/* Name */}
      <div className="pt-6 text-center font-semibold text-lg
        text-[#0D3744] dark:text-[#2A96B8]">
        {data.attendeeName}
      </div>

      {/* Date */}
      <div className="text-center mt-4 mb-6 text-base
        text-gray-700 dark:text-gray-300">
        {moment.utc(data.startDate).local().format("DD/MM/YYYY hh:mm:ss A")}
      </div>
      <div
        onClick={() => setShowDeleteDialog(true)}
        className="
          mt-auto py-3 text-center cursor-pointer
          bg-slate-50 dark:bg-slate-800
          text-red-600
          hover:bg-red-50 dark:hover:bg-red-900/20
          transition-colors
        "
      >
        Kill Session
      </div>

      {/* Confirm Dialog */}
      <ConfirmDialogBox
        visible={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        onConfirm={() => {
          setShowDeleteDialog(false);
          deleteHandler();
        }}
        title={
          <>Are you sure you want to Delete this session?</>
        }
        confirmLabel="Delete"
        cancelLabel="Cancel"
      />
    </div>
  );
};

export default SessionCard;